import React from "react";
//connect can also be used with functional components if need be
import { connect } from 'react-redux';
import { showModal } from '../../actions';
//found this on npm web site. . . https://www.npmjs.com/package/react-modal
//npm install --save react-modal
//I don't remember where I got the idea to use react-modal. This is not the way
//Stephen Grider approached doing modals. He did it manually.
import Modal from "react-modal";


Modal.setAppElement("#root");

class Gallery extends React.Component {
    state = {
        imageLoaded: false,
        imageLoadError: false
    };

    toggleModal = () => {
        this.props.showModal(!this.props.isOpen, '', '', '');
    };


    onViewDocument = (document, description, index) => {
        this.setState({ imageLoaded: false, imageLoadError: false });
        this.props.showModal(true, document, description, index);
    };
    //props.images might be from this.props.dropdownImages or from this.props.portfolioImages
    //for portfolio return true since we want to show all the images
    //for drop down, return only a series of images that fall under the given group selected
    imagesFilter = (image) => {
        let bool = false;
        switch (window.location.pathname) {
            case "/Portfolio":
                bool = true;
                break;
            case "/Images":
                if (this.props.dropdownSelection === image.description) {
                    bool = true;
                }
                break;
            default: {
                bool = false;
            }
        }
        return bool;
    }

    //This is a hack to add dummy images to the end of the list of portfolio images so that the last row of images
    //  will be full and prevent css issues regarding image sizing on the final row. I arbitrarily added 15 dummy images 
    // at the end of the list of images (15 is likely enough for this). These dummy images have a class name 'dummy'
    addDummyImages = () => {
        const dummyImages = [];
        for (let i = 0; i < 15; i++) {
            dummyImages.push(
                <li key={`dummy-${i}`} className="column imageDescription portfolio dummy">
                    {/* <div style={{ width: '100px', height: '100px', backgroundColor: '#ccc' }}></div> */}
                    <div style={{ width: '100px', height: '100px' }}></div>
                </li>
            );
        }
        return dummyImages;
    }


    renderList = () => {
        const renderedImages = [];

        this.props.images.forEach((image, index) => {
            if (this.imagesFilter(image) === false) { return; }

            renderedImages.push(
                <li key={`${image.index}-${index}`} className={`column imageDescription portfolio ${image.type} ${image.specifictype}`}>
                    <a href="#!">
                        <img onClick={() => this.onViewDocument(`${image.imagepath}${image.index}a.jpg`, image.description, image.index)}
                            src={`${image.imagepath}${image.index}a-thumb.jpg`}
                            alt={`${image.description}`}
                            loading="lazy"
                            className="portfolioImage image high-quality" />
                    </a>
                    <div style={{ width: window.innerWidth > 768 ? '150px' : '100px' }} className="breakword portfolioOverlay">{`${image.description} (${image.index})`}</div>
                </li>
            );
        });
        //if the window is 768px, which is wide enough, add dummy images to fill out the last row of images on the portfolio page
        if (window.innerWidth > 768 && renderedImages.length > 0) { //768px is the breakpoint for the media query in Site.css for the portfolio page (also see E:\react.redux.demoapp\src\index.js for the device detection code)
            renderedImages.push(...this.addDummyImages());
        }
        //DO NOT REMOVE THIS React.Fragment
        return <React.Fragment>{renderedImages}</React.Fragment>
    }

    render() {
        return (
            <div align="center">
                <Modal
                    isOpen={this.props.isOpen}
                    onRequestClose={this.toggleModal}
                    contentLabel="My dialog"
                    className="mymodal"
                    overlayClassName="myoverlay"
                    closeTimeoutMS={500}
                >
                    {!this.state.imageLoaded && !this.state.imageLoadError && (
                        <div className="loader1" role="status" aria-label="Loading image" />
                    )}
                    {this.state.imageLoadError && <div role="alert">Unable to load image.</div>}
                    <img
                        src={this.props.document}
                        alt={`${this.props.description}`}
                        onLoad={() => this.setState({ imageLoaded: true, imageLoadError: false })}
                        onError={() => this.setState({ imageLoaded: false, imageLoadError: true })}
                        style={{ visibility: this.state.imageLoaded ? 'visible' : 'hidden' }}
                        className="modalImage image high-quality crisp-edges"
                    />
                    <div style={{ position: 'relative', top: '1vh', }} align="center">
                        <button onClick={this.toggleModal}>Close</button>
                    </div>
                    <div style={{ position: 'relative', top: '1vh', }} align="center">
                        {`${this.props.description} ${this.props.index}`}
                    </div>
                </Modal>
                {/* Navigation components go here */}
                <div>{this.props.children}</div>
                <div>
                    <ul className="no-bullets portfolio">
                        {this.renderList()}
                    </ul>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        isOpen: state.modal.isOpen,
        document: state.modal.document,
        description: state.modal.description,
        index: state.modal.index,
        dropdownSelection: state.dropdownSelection.selection
    };
}
//NOTE action creators included here
export default connect(mapStateToProps, { showModal: showModal })(Gallery);
